"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeatSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path d="M14 5.665c-.736 0-1.333.597-1.333 1.333v12.95a3.332 3.332 0 1 0 4.619 3.617 3.332 3.332 0 0 0-1.952-3.617V6.998c0-.736-.597-1.333-1.334-1.333Z"></path><path fill-rule="evenodd" d="M19 18.105V6.998A5 5 0 0 0 14 2a5 5 0 0 0-5 4.998v11.107a6.996 6.996 0 0 0 .067 9.862 7.002 7.002 0 0 0 9.866 0A6.996 6.996 0 0 0 19 18.105Zm-5 9.887a5 5 0 0 1-3.57-8.498l.57-.58V6.999a3 3 0 0 1 6 0v11.917l.57.58A4.997 4.997 0 0 1 14 27.991Z" clip-rule="evenodd"></path><path d="M19.667 6.998a1 1 0 0 1 1-1H24a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1Z"></path><path d="M20.667 11.33a1 1 0 1 0 0 2H24a1 1 0 1 0 0-2h-3.333Z"></path><path d="M19.667 17.662a1 1 0 0 1 1-1H24a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1Z"></path><path d="M20.667 8.665a1 1 0 1 0 0 1.999h2a1 1 0 1 0 0-2h-2Z"></path><path d="M19.667 14.996a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z"></path></g>';
var HeatSVG = function HeatSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HeatSVG = HeatSVG;
HeatSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HeatSVG);
exports.default = _default;